var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-link.ts
import { ElementsLink } from "@adornis/chemistry/elements/components/x-link";
import { customElement } from "lit/decorators.js";
import { buttonStyles } from "./ge-button";
var GermaniumLink = class extends ElementsLink {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ":host": {
        display: "inline-block",
        ...buttonStyles[":host([mode=landing-text])"]
      },
      ":host([neutral])": { color: "inherit" }
    });
  }
};
GermaniumLink = __decorateClass([
  customElement("ge-link")
], GermaniumLink);
export {
  GermaniumLink
};
